/* @flow */
import cx from 'classnames';
import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import ChatMessage from 'entities/ChatMessage';
import ChatMessageStore from 'chat/stores/ChatMessageStore';
import CurrentUser from 'auth/CurrentUser';
import MessageItem from './MessageItem.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import UserLink from 'users/components/UserLink.jsx';

import './styles/MessageListItem.scss';

type Props = {
  messages: ChatMessage[],
  isGroupChat?: boolean,
  disabled?: boolean,
};

class MessageListItem extends React.Component {

  props: Props;

  static defaultProps = {
    disabled: false,
    isGroupChat: false,
  };

  shouldComponentUpdate(nextProps: Props) {
    return shallowCompare(this, nextProps, null);
  }

  getSender() {
    const { messages } = this.props;
    const firstMessage = messages[0];
    return firstMessage.getSender();
  }

  sentByCurrentUser() {
    return CurrentUser.getUserId() === this.getSender().id;
  }

  renderName() {
    const sender = this.getSender();
    const modal = <RelationshipModal userId={sender.id} />;

    return (
      <ModalTrigger modal={modal}>
        <UserLink
          userId={sender.id}
          neverShowStartChat={!this.props.isGroupChat}
          placement="right"
          color="inherit"
          alignment="top">
          <span
            className={cx('MessageListItem-name', {
              'MessageListItem-disabled': this.props.disabled,
            })}
            disabled={this.props.disabled}>
            {sender.getName()}
          </span>
        </UserLink>
      </ModalTrigger>
    );
  }

  renderMessage(message: ChatMessage, isCurrentUser: boolean, lastOfGroup: boolean) {
    const sender = this.getSender();
    return (
      <MessageItem
        key={message.getUuid()}
        failed={ChatMessageStore.hasMessageFailed(message)}
        message={message}
        sentBySelf={isCurrentUser}
        senderColor={sender.getColor()}
        senderInitials={sender.getInitials()}
        lastOfGroup={lastOfGroup}
      />
    );
  }

  renderContent() {
    const { messages } = this.props;
    const sentByCurrentUser = this.sentByCurrentUser();
    const messageItems = messages.map(message => {
      const lastOfGroup = message === messages[messages.length - 1];
      return this.renderMessage(message, sentByCurrentUser, lastOfGroup);
    });

    if (sentByCurrentUser) {
      return <div className="MessageListItem-content">{messageItems}</div>;
    }

    return (
      <div className="MessageListItem-messageGroup">
        <div className="MessageListItem-contentWrap">
          {this.renderName()}
          <div className="MessageListItem-content">
            {messageItems}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const sentByCurrentUser = this.sentByCurrentUser();

    return (
      <li
        className={cx('MessageListItem', {
          'MessageListItem-self': sentByCurrentUser,
          'MessageListItem-other': !sentByCurrentUser,
        })}>
        {this.renderContent()}
      </li>
    );
  }
}

export default MessageListItem;



// WEBPACK FOOTER //
// ./src/chat/components/MessageListItem.jsx